module.exports = {
  'Anaesthetic':'MEDICATIONS.V2.FORM.OPTION.ADMINISTERED.ANAESTHETIC',
  'Capsule':'MEDICATIONS.V2.FORM.OPTION.ADMINISTERED.CAPSULE',
  'Cream':'MEDICATIONS.V2.FORM.OPTION.ADMINISTERED.CREAM',
  'Dermal Patch':'MEDICATIONS.V2.FORM.OPTION.ADMINISTERED.DERMAL_PATCH',
  'Ear Drop':'MEDICATIONS.V2.FORM.OPTION.ADMINISTERED.EAR_DROP',
  'Eye Drop':'MEDICATIONS.V2.FORM.OPTION.ADMINISTERED.EYE_DROP',
  'Eye Ointment':'MEDICATIONS.V2.FORM.OPTION.ADMINISTERED.EYE_OINTMENT',
  'Gas':'MEDICATIONS.V2.FORM.OPTION.ADMINISTERED.GAS',
  'Gel':'MEDICATIONS.V2.FORM.OPTION.ADMINISTERED.GEL',
  'Inhaler':'MEDICATIONS.V2.FORM.OPTION.ADMINISTERED.INHALER',
  'Intramuscular Injection':'MEDICATIONS.V2.FORM.OPTION.ADMINISTERED.INTRAMUSCULAR_INJECTION',
  'Intravenous infusion':'MEDICATIONS.V2.FORM.OPTION.ADMINISTERED.INTRAVENOUS_INFUSION',
  'Liquid sachet':'MEDICATIONS.V2.FORM.OPTION.ADMINISTERED.LIQUID_SACHET',
  'Lotion':'MEDICATIONS.V2.FORM.OPTION.ADMINISTERED.LOTION',
  'Nasal Drop':'MEDICATIONS.V2.FORM.OPTION.ADMINISTERED.NASAL_DROP',
  'Nasal ointment':'MEDICATIONS.V2.FORM.OPTION.ADMINISTERED.NASAL_OINTMENT',
  'Ointment':'MEDICATIONS.V2.FORM.OPTION.ADMINISTERED.OINTMENT',
  'Pessary':'MEDICATIONS.V2.FORM.OPTION.ADMINISTERED.PESSARY',
  'Powder sachet':'MEDICATIONS.V2.FORM.OPTION.ADMINISTERED.POWDER_SACHET',
  'Subcutaneous Injection':'MEDICATIONS.V2.FORM.OPTION.ADMINISTERED.SUBCUTANEOUS_INJECTION',
  'Suppository':'MEDICATIONS.V2.FORM.OPTION.ADMINISTERED.SUPPOSITORY',
  'Tablet':'MEDICATIONS.V2.FORM.OPTION.ADMINISTERED.TABLET'
};
